import { useQuery } from '@tanstack/react-query'
import { fetchCompanyOverviewTableOverviewData } from '../../services/verticalsTablesApi'
import { Filter } from 'components/FilterDrawer/FilterDrawer.config'

interface UseNexusOverviewQueryProps {
  verticalIndices: string
  currentQueryKey: string
  searchValue: string
  filters?: Filter[]
}

export const useNexusOverviewQuery = ({
  verticalIndices,
  currentQueryKey,
  searchValue,
  filters,
}: UseNexusOverviewQueryProps) =>
  useQuery({
    queryKey: [currentQueryKey, verticalIndices, searchValue, filters],
    queryFn: ({ signal }) =>
      verticalIndices ? fetchCompanyOverviewTableOverviewData(verticalIndices, searchValue, filters, signal) : null,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
  })
